/**
 * The class that hides text from the eye but not from screen readers (a caption, a count read out, "changed to").
 * One rule in tokens.scss, global, so it also works in dialogs portalled outside `.cy-next`.
 */
export const VISUALLY_HIDDEN = "cy-visually-hidden";
